import { useLocation } from "@builder.io/qwik-city";
import { useSignal, useTask$ } from "@builder.io/qwik";

/**
 * Hook that tracks navigation state and returns whether the route is currently loading
 * @returns Signal indicating if navigation is in progress
 */
export const useNavigationLoading = () => {
  const location = useLocation();
  const isLoading = useSignal(false);
  const currentPath = useSignal(location.url.pathname);

  useTask$(({ track, cleanup }) => {
    track(() => location.isNavigating);
    track(() => location.url.pathname);

    // Only show loading if we're navigating to a new path
    if (location.isNavigating && location.url.pathname !== currentPath.value) {
      isLoading.value = true;
      currentPath.value = location.url.pathname;
    } else if (!location.isNavigating) {
      const timeout = setTimeout(() => {
        isLoading.value = false;
      }, 500);
      cleanup(() => clearTimeout(timeout));
    }
  });

  return isLoading;
};
